/* 51Talk的家长启蒙页面：亲子100问+家长学院+外部文章超链 */
/*  Author: wanfengren */
/* create: 2019/08/15 */
/* update: 2020/11/12 */
<template>
<div class="flex-center flex-column mainbody" id="textDiv">
  <!-- 通用介绍 -->
  <div class="header-panel">
    <div class="header-title" v-bind:style="{fontSize: changeTitleFontSize() + 'px'}"><span>{{Data.title}}</span></div>
  </div>

  <!-- <div class="headertitle" v-bind:style="{fontSize: changeTitleFontSize() + 'px'}">{{Data.title}}</p></div> -->

   <!-- 亲子100问视频和图片 class="resource resource_book" -->
  <div v-if="Data.source_platform === '51Talk-亲子100问' && Data.audio_link.length > 0">
    <p><span class="resource-title">
        <span class="fa fa-star"></span>
        <strong>51Talk亲子100问</strong></span>
    </p>

    <div class="resource-content intro">
      <img class="daily_word_img" :src="Data.cover_link">
      <p>快来听听Nancy老师给我们答疑吧：</p>
      <audio id="media_link" class="audio_dailyword" controls="controls" :src="Data.audio_link">
       您的浏览器不支持 audio 标签。
       </audio>
    </div>

    <!-- 亲子100问文字版 -->
    <div class="maintext">
      <div class="flex-row-left" v-html="addDiv(Data.content)"></div>
    </div>
  </div>

  <!-- 家长学院视频 -->
  <div v-else-if="Data.source_platform === '51Talk-家长学院' && Data.video_link.length > 0" class="resource-content intro">
      <img class="parent_img" :src="Data.cover_link">
      <div class="flex-row-left" v-html="addDiv(Data.content)"></div>
      <p>
        51Talk今天给家长朋友们带来的主题是《<span class="orange-bold">{{Data.title}}</span>》，这个主题跟
        <span v-for= "el in Data.subject" v-text="el.subject + '/'"></span>相关，
        观看完成大概需要40-60分钟哟！
      </p>

      <div class="flex-row-center">
          <iframe id="video_link" class="video_iframe" style="z-index:1;"
          :src="Data.video_link" allowfullscreen="" frameborder="0"
          :width="MAXWIDTH"
          :height="MAXHEIGHT"
          ></iframe>
      </div>
      <!-- <div class="flex-row-center">
        <video id="video_link" class="video_iframe" controls="controls"
        preload = "preload" :src="Data.video_link"
          :width="MAXWIDTH"
          :height="MAXHEIGHT"
          ></video>
      </div> -->
    </div>

      <!-- 学术资源库答疑 -->
    <div v-else-if="Data.source_platform === '51Talk-学术资源库'" class="resource-content intro">
        <img v-if="Data.cover_link" class="parent_img" :src="Data.cover_link">
        <div v-if="Data.content" class="flex-row-left" v-html="addDiv(Data.content)"></div>

        <div v-if="Data.video_link" class="flex-row-center">
            <iframe id="video_link" class="video_iframe" style="z-index:1;"
            :src="Data.video_link" allowfullscreen="" frameborder="0"
            :width="MAXWIDTH"
            :height="MAXHEIGHT"
            ></iframe>
        </div>
    </div>


    <!-- 家长小课堂-->
  <div v-else-if="Data.source_platform === '51Talk-家长小课堂' && Data.video_link.length > 0" class="resource-content intro">
      <img class="parent_img" :src="Data.cover_link">
      <div v-if="Data.content" class="flex-row-left" v-html="addDiv(Data.content)"></div>
      <p>
        51Talk今天邀请牛津大学二语习得专家Anna老师来给大家解答有关《<span class="orange-bold">{{Data.title}}</span>》疑问，
        仅需1-3分钟即可快速了解，一起来看看吧！
      </p>

        <div class="flex-row-center">
            <iframe id="video_link" class="video_iframe" style="z-index:1;"
            :src="Data.video_link" allowfullscreen="" frameborder="0"
            :width="MAXWIDTH"
            :height="MAXHEIGHT"
            ></iframe>
        </div>
   </div>

   <!-- 51talk自研内容：仅有文章内容无链接 -->
   <div v-else-if="Data.source_platform === '51Talk' && Data.content != null" class="maintext">
     <div class="flex-row-left" v-html="addDiv(Data.content)"></div>
   </div>

  <!-- 其他异常情况处理 -->
  <div v-else class="maintext" >
    <div v-if='Data.link'>
      亲爱的家长朋友，目前51Talk家长启蒙内容板块仅包含<span class="orange-bold">亲子100问和家长学院</span>相关自研内容，外部内容来自于教学运营团队给给大家精选推荐：</p>
     <p>
      立即点击查看：<a :href="Data.link" ><span class='blue-bold'> {{Data.title}} </span></a>
    </p>
    </div>
    <p v-else>
      亲爱的家长朋友，当前链接出错了，无相应的文章！目前此家长启蒙内容板块仅包含<span class="orange-bold">亲子100问和家长学院</span>相关自研内容，外部内容正在寻找中~~ 敬请谅解！
    </p>
  </div>

</div>
</template>

<script>
import BaseVue from '@/components/BaseVue'

export default {
  name: 'ParentArticleTemplate',
  extends: BaseVue,
  data() {
    return {
      Data: {
        id: 86,
        title: '51Talk亲子100问',
        source_platform: '',
        subject: [{id: 7, suject: '自然拼读'}],
        link: '',
        cover_link: '',
        audio_link: '',
        video_link: '',
        min_age: 3,
        max_age: 8,
        content: '',
        url_params: '',
        // title: '为什么要学自然拼读而不是国际音标',
        // source_platform: '51Talk-亲子100问',
        // cover_link: 'http://s.kg.51talkjr.com/fab98f18-15ba-4c23-b189-efe56c137d74.jpg',
        // audio_link: 'http://s.kg.51talkjr.com/8a1012e2-c394-4b51-9aa7-136561701dc2.mp3',
        // content: '<p style="text-indent:2em">各位家长朋友们，大家好，我是51Talk的Nancy老师，又和大家见面了。</p><p style="text-indent:2em">今天我们来聊一聊自然拼读和国际音标的问题。国际音标（英语：International Phonetic Alphabet，缩写：IPA），是一套用来标音的系统，以拉丁字母为基础，由国际语音学学会设计来作为口语声音的标准化标示方法。<span class="orange-bold">自然拼读的核心是建立字母或字母组合与其发音的音形对应关系，以及连音成词的拼读技巧</span>。理论上讲，学会音标只要有单词有音标就能会读，但在没有音标只有单词的情况下，不知道字母与音的联系，就无法读出单词。</p><p style="text-indent:2em">如：单词cat，单词中的字母的发音是用国际音标中的字符进行表示的，c的发音表示为/k/，a的发音表示为/æ/，t的发音表示为/t/，这些字符与发音紧密联系，而单词中的字母并未与发音建立直接联系，（字母—音标—发音），因此脱离了音标，便无法读出单词。</p><p style="text-indent:2em">实际上，英语的字母本身是可以表音的，比如t对应的发音是/t/，s对应的发音是/s/，这就是说在不借助任何工具的情况下，是可以通过学习掌握字母或字母组合相对应的发音，将发音连接起来，从而完成单词的拼读的。</p><p style="text-indent:2em">如：在单词sit中, s的发音是/s/，i的发音是/i/，t的发音是/t/，将三个发音连接起来，/s/-/i/-/t/，即可拼读出单词sit/sit/.从中我们可以看出，国际音标是具象声音的抽象总结，枯燥、难懂，不太容易进行具体学习操作，低幼儿童学习音标会加重其学习负担浪费孩子很多宝贵时间。事实上，低幼儿童处于语音的敏感期，他们对细微的发音最为敏感，模仿也最快，因此，<span class="orange-bold">学习自然拼读是效率更高的一种选择</span>。</p><p style="text-indent:2em">好了，以上就是本期《亲子100问》的内容，感谢大家收听今天的51Talk亲子100问，我们下期不见不散</p>
      }
    }
  },
  computed: {
    tailUrl: function() {
      return this.url_params === '' ? '' : '?' + this.url_params
    }
  },
  created: function() {
    let data_id = this.$route.params.id
    // let url = this.APIHOST_ORIGINAL + 'parent_article/' + data_id + '?format=json&cipher=0'  //test can use the cipher=0 para
    let url = this.APIHOST + 'parent_article/' + data_id + '?format=json&cipher=0'
    this.url_params = this.$route.fullPath.split('?')[1]
    let that = this;
    this.queryData(url, function(data) {
      that.Data = data
      if (that.Data.video_link){
        that.Data.video_link = that.resetVideoSize(that.Data.video_link)
      }
    })
  },
  methods: {
    changeTitleFontSize: function(){
      if (window.innerWidth >500) return 20
      return  parseInt(375 / (12+this.Data.title.toString().length))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/resource/ParentArticle.vue